import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute flex space-x-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-10 rounded-lg skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-28 lg:w-64 skeleton-unit" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center opacity-0" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 material-icons" }, "book"),
    /*#__PURE__*/_createElementVNode("h3", null, " ")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "relative h-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute flex flex-col w-full h-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-3/5 h-3 mb-1 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-3/5 h-3 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-3 mt-8 mb-1 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-3 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-3 my-1 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-3 mb-auto skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 mx-auto mt-auto rounded-lg skeleton-unit" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center opacity-0" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, " "),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, " ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "h-80",
    hoverable: false
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}